import BaseModel from "../../base/baseModel";

export default class InformacoesNfeModel extends BaseModel {
    tipoAmbiente = 0;
    chave: string = null;
    protocolo: string = null;
}
